import $ from 'jquery';

export default function enablePreloader() {
  let preloaded = false;

  setTimeout(() => {
  		preloaded = true;
  }, 3500)

  $(document).ready(()=> {
  	let preloader = $('.preloader');

  	if(preloaded) {
  			hideElem(preloader);
  	} else {
  		setTimeout(() => {
  			hideElem(preloader);
  		}, 3500)
  	}



  })


  function hideElem(elem) {

  	elem.css({'opacity': '0'});

  	setTimeout(() => {
  		elem.css({'display': 'none'});
  	}, 1000)
  }
}



// WEBPACK FOOTER //
// ./src/js/preloader.js